import React, { Component } from "react";
import { Button, } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";
import {ToastContainer} from "react-toastify";

import QuarantinePanel from "./Components/QuarantinePanel";

import HeaderPanel from "../Home/Components/HeaderPanel";
import ModalContextMenu from "../Home/Components/ModalContextMenu";


export default class QuarantinePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quarantineLines : []
    }

    this.onContextMenuRequest = this.onContextMenuRequest.bind(this);
    this.onContextMenuCloseRequest = this.onContextMenuCloseRequest.bind(this);
  }


  onContextMenuRequest() {
    this.setState({ showContextMenu: true });
  }
  
  onContextMenuCloseRequest() {
    this.setState({ showContextMenu: false });
  }

    render() {
      const myQuarantineLines = this.state.quarantineLines || [];
      return (
  
        <div style={{ overflowX: "hidden", display: "flex", flexDirection: "column" }}>
          
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

        <ModalContextMenu
          show={this.state.showContextMenu}
          onContextMenuCloseRequest={this.onContextMenuCloseRequest}
          onLogoutRequest={this.props.onLogoutRequest}
          onHomePageRequest = {this.props.onHomePageRequest}
          userSession={this.props.userSession}
        />
        <HeaderPanel
          deviceInfo={this.props.deviceInfo}
          appInfo={this.props.appInfo}
          onlineInfo={this.props.onlineInfo}
          userSession={this.props.userSession}
          onContextMenuRequest={this.onContextMenuRequest}
          onHomePageRequest={this.props.onHomePageRequest}
        />
          <QuarantinePanel
            isConnected = {this.props.isConnected}
            userSession={this.props.userSession}
            onNotifyEvent={this.notify}
          />
          
  
        </div>
  
      );
    }


  }